import { Routes as SettingRoutes } from "ui/modules/navigation";
import { PageTitle } from "./types";

/*------------------------------------------------------------------
  PLATFORMA
-------------------------------------------------------------------*/

export const SETTING_APPLICATION_DASHBOARD_PAGE_TITLE: PageTitle = {
  text: "Nadzorna ploča",
  // Vlastita ikona, ne zupčanik: nadzorna ploča više nije dio postavki platforme nego je
  // prva stavka izbornika i početni ekran.
  icon: "/media/icons/dashboard.svg",
  iconColor: "stroke-[#edeef8]",
  route: SettingRoutes.DashboardPageRouter,
};

export const APPLICATION_SETTINGS_PAGE_TITLE: PageTitle = {
  text: "Postavke aplikacije",
  icon: "/media/icons/setting.svg",
  iconColor: "stroke-[#edeef8]",
  route: SettingRoutes.ApplicationSettingsPageRouter,
};

/*------------------------------------------------------------------
  TENANTI
-------------------------------------------------------------------*/

export const TENANT_SEARCH_PAGE_TITLE: PageTitle = {
  text: "Tenanti",
  icon: "/media/icons/company.svg",
  iconColor: "stroke-[#edeef8]",
  route: SettingRoutes.TenantSearchPageRouter,
};

export const TENANT_DETAIL_PAGE_TITLE: PageTitle = {
  text: "Detalji tenanta",
  icon: "/media/icons/company.svg",
  iconColor: "stroke-[#edeef8]",
  route: SettingRoutes.TenantDetailPageRouter,
};

/*------------------------------------------------------------------
  CJENIK
-------------------------------------------------------------------*/

export const PRICING_PAGE_TITLE: PageTitle = {
  text: "Cjenik",
  icon: "/media/icons/dollar.svg",
  iconColor: "stroke-[#edeef8]",
  route: SettingRoutes.PricingPageRouter,
};

export const PRICING_SCHEMES_PAGE_TITLE: PageTitle = {
  text: "Cjenovne grupe",
  icon: "/media/icons/dollar.svg",
  iconColor: "stroke-[#edeef8]",
  route: SettingRoutes.PricingSchemesPageRouter,
};

export const PRICING_DEVIATIONS_PAGE_TITLE: PageTitle = {
  text: "Posebni uvjeti",
  icon: "/media/icons/dollar.svg",
  iconColor: "stroke-[#edeef8]",
  route: SettingRoutes.PricingDeviationsPageRouter,
};

/*------------------------------------------------------------------
  PRIJEVODI
-------------------------------------------------------------------*/

export const TRANSLATION_SEARCH_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.translation.search", //"Prijevodi",
  icon: "/media/icons/languages.svg",
  iconColor: "stroke-[#edeef8]",
  route: SettingRoutes.TranslationSearchPageRouter,
};

export const TRANSLATION_NEW_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.translation.add", //"Unos prijevoda",
  icon: "/media/icons/add.svg",
  iconColor: "stroke-[#edeef8]",
  route: SettingRoutes.TranslationCreatePageRouter,
};

export const TRANSLATION_EDIT_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.translation.edit", //"Ažuriranje prijevoda",
  icon: "/media/icons/edit.svg",
  iconColor: "stroke-[#edeef8]",
  route: SettingRoutes.TranslationEditPageRouter,
};

export const TRANSLATION_DELETE_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.translation.delete", //"Brisanje prijevoda",
  icon: "/media/icons/edit.svg",
  iconColor: "stroke-[#edeef8]",
  route: SettingRoutes.TranslationDeletePageRouter,
};

/*------------------------------------------------------------------
  OBRADE
-------------------------------------------------------------------*/

export const CRON_JOB_SEARCH_PAGE_TITLE: PageTitle = {
  text: "Obrade",
  icon: "/media/icons/task.svg",
  iconColor: "stroke-[#edeef8]",
  route: SettingRoutes.CronJobSearchPageRouter,
};

export const CRON_JOB_DETAIL_PAGE_TITLE: PageTitle = {
  text: "Vrsta obrade",
  icon: "/media/icons/task.svg",
  iconColor: "stroke-[#edeef8]",
  route: SettingRoutes.CronJobDetailPageRouter,
};

export const CRON_JOB_EXECUTION_PAGE_TITLE: PageTitle = {
  text: "Log obrade",
  icon: "/media/icons/history.svg",
  iconColor: "stroke-[#edeef8]",
  route: SettingRoutes.CronJobExecutionPageRouter,
};
